import { useAtom } from "jotai";
import { useEffect, useMemo } from "react";
import { SelectionColor } from "../../blocks/Block";
import { colorValue } from "../../css/color";
import { selectionAtom } from "../../jotai/atoms";
import { useUserInfos } from "../../liveblocks/maps";
import { usePresence } from "../../liveblocks/presences";
import { Block, Presence, Selection } from "../../types";

export default function useSelectionPresence() {
  const [selection] = useAtom<Selection>(selectionAtom);
  const [selectionPresence, updateOwn] =
    usePresence<Presence["selection"]>("selection");
  const [users] = useUserInfos();

  useEffect(() => {
    updateOwn({ selection });
  }, [selection, updateOwn]);

  const selections = useMemo(() => {
    const res: { blockId: string; userId: string; selectedAt: number }[] = [];

    for (const userId in selectionPresence) {
      const sel = selectionPresence[userId];
      for (const blockId in sel) {
        const selectedAt = sel[blockId];
        res.push({ userId, blockId, selectedAt });
      }
    }

    res.sort((a, b) => b.selectedAt - a.selectedAt);

    if (!users) {
      return {};
    }

    const byBid = res.reduce((acc, cur) => {
      if (acc[cur.blockId]) {
        return acc;
      }

      const userColor = users[cur.userId]?.color;
      acc[cur.blockId] = colorValue(userColor, 60);

      return acc;
    }, {} as Record<Block["id"], SelectionColor>);

    return byBid;
  }, [selectionPresence, users]);

  return selections;
}
